/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CalculateTaxQueryVariables = GraphQL.Exact<{
  country: GraphQL.Scalars['String']['input'];
  state: GraphQL.InputMaybe<GraphQL.Scalars['String']['input']>;
  tariff: GraphQL.Scalars['String']['input'];
  vatNumber: GraphQL.InputMaybe<GraphQL.Scalars['String']['input']>;
}>;


export type CalculateTaxQuery = { readonly __typename?: 'Query', readonly tax: { readonly __typename?: 'Tax', readonly country: string | null, readonly id: CK.ID, readonly isEstimate: boolean, readonly rate: CK.Percentage, readonly type: GraphQL.TaxType | null } };


export const CalculateTaxDocument = gql`
    query CalculateTax($country: String!, $state: String, $tariff: String!, $vatNumber: String) {
  tax(country: $country, state: $state, tariff: $tariff, vatNumber: $vatNumber) {
    country
    id
    isEstimate
    rate
    type
  }
}
    `;

/**
 * __useCalculateTaxQuery__
 *
 * To run a query within a React component, call `useCalculateTaxQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateTaxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateTaxQuery({
 *   variables: {
 *      country: // value for 'country'
 *      state: // value for 'state'
 *      tariff: // value for 'tariff'
 *      vatNumber: // value for 'vatNumber'
 *   },
 * });
 */
export function useCalculateTaxQuery(baseOptions: Apollo.QueryHookOptions<CalculateTaxQuery, CalculateTaxQueryVariables> & ({ variables: CalculateTaxQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateTaxQuery, CalculateTaxQueryVariables>(CalculateTaxDocument, options);
      }
export function useCalculateTaxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateTaxQuery, CalculateTaxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateTaxQuery, CalculateTaxQueryVariables>(CalculateTaxDocument, options);
        }
export function useCalculateTaxSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CalculateTaxQuery, CalculateTaxQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CalculateTaxQuery, CalculateTaxQueryVariables>(CalculateTaxDocument, options);
        }
export type CalculateTaxQueryHookResult = ReturnType<typeof useCalculateTaxQuery>;
export type CalculateTaxLazyQueryHookResult = ReturnType<typeof useCalculateTaxLazyQuery>;
export type CalculateTaxSuspenseQueryHookResult = ReturnType<typeof useCalculateTaxSuspenseQuery>;
export type CalculateTaxQueryResult = Apollo.QueryResult<CalculateTaxQuery, CalculateTaxQueryVariables>;